/**
 * Created by Andrey Popov on 4/21/25.
 */

const OrderStars = function (slot) {
    this.slot = slot;

    this.load();
};

OrderStars.prototype.load = function () {
    this.stars = this.slot.load("stars") || 0;

    if (this.stars > OrderStars.MAX_STARS) {
        cleverapps.throwAsync(`order stars too big on load: ${this.stars}`);
        this.stars = OrderStars.MAX_STARS;
        this.slot.save("stars", this.stars);
    }
};

OrderStars.MAX_STARS = 1000000000;

OrderStars.prototype.getAmount = function () {
    return this.stars;
};

OrderStars.prototype.isEnoughStars = function () {
    const location = cleverapps.meta.getSelectedLocation();
    return this.stars >= location.calcStarsForStage();
};

OrderStars.prototype.addStars = function (stars, silent) {
    if (this.stars + stars > OrderStars.MAX_STARS) {
        cleverapps.throwAsync(`order stars too big: ${stars} to ${this.stars}`);
        return;
    }

    this.stars += stars;
    this.slot.save("stars", this.stars);

    if (!silent) {
        this.onChangeStars();
    }

    cleverapps.eventBus.trigger("add_stars", stars);
};

OrderStars.prototype.canTakeStars = function (stars) {
    if (stars > this.stars) {
        cleverapps.notification.create(Messages.get("NoStars"));
        return false;
    }

    return true;
};

OrderStars.prototype.takeStars = function (stars, silent) {
    if (!this.canTakeStars(stars)) {
        return false;
    }

    this.stars -= stars;

    this.slot.save("stars", this.stars);

    if (!silent) {
        this.onChangeStars();
    }

    return true;
};

OrderStars.prototype.onChangeStars = function () {
    cleverapps.meta.getSelectedLocation().trigger("changeStars");
};